import { apiFetch } from "./client";

export interface ChatNotificationItem {
  messageId: string;
  sessionId: string;
  sessionTitle: string;
  agentId: string | null;
  agentName: string;
  channelId: string | null;
  channelName: string | null;
  channelShared: boolean;
  content: string;
  createdAt: string;
  directToMe: boolean;
}

export interface ChatUnreadResponse {
  items: ChatNotificationItem[];
  count: number;
}

export const chatNotificationsApi = {
  listUnread: (companyId: string, limit = 50) =>
    apiFetch<ChatUnreadResponse>(
      `/chat/unread?companyId=${encodeURIComponent(companyId)}&limit=${limit}`,
    ),

  markSessionRead: (sessionId: string) =>
    apiFetch<{ ok: boolean; lastReadAt: string }>(
      `/chat/sessions/${sessionId}/read`,
      { method: "POST" },
    ),

  markAllRead: (companyId: string) =>
    apiFetch<{ ok: boolean; stamped: number; lastReadAt: string }>(
      `/chat/mark-all-read?companyId=${encodeURIComponent(companyId)}`,
      { method: "POST" },
    ),
};
